import React, { createContext, useContext, useState, useEffect } from 'react';
import { api } from '../../config/api';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      checkToken();
    }
  }, []);

  const checkToken = async () => {
    try {
      await api.getWordLists();
      setIsAuthenticated(true);
    } catch (err) {
      console.error('Token jest nieprawidłowy:', err);
      localStorage.removeItem('token');
      setIsAuthenticated(false);
      throw err;
    }
  };

  const login = async (email, password) => {
    setError('');
    setIsLoading(true);

    try {
      const data = await api.login(email, password);
      if (data.error) {
        throw new Error(data.error);
      }
      if (!data.token) {
        throw new Error('Nie otrzymano tokenu z serwera');
      }
      localStorage.setItem('token', data.token);
      setIsAuthenticated(true);
      return true;
    } catch (err) {
      console.error('Błąd logowania:', err);
      setError(err.message || 'Wystąpił błąd podczas logowania');
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  const registerInit = async (email, password) => {
    setError('');
    setIsLoading(true);

    try {
      const data = await api.registerInit(email, password);
      if (data.error) {
        throw new Error(data.error);
      }
      return {
        success: true,
        verificationId: data.verificationId,
        message: data.message
      };
    } catch (err) {
      console.error('Błąd inicjalizacji rejestracji:', err);
      setError(err.message || 'Wystąpił błąd podczas inicjalizacji rejestracji');
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  const registerVerify = async (verificationId, code) => {
    setError('');
    setIsLoading(true);

    try {
      const data = await api.registerVerify(verificationId, code);
      if (data.error) {
        throw new Error(data.error);
      }
      if (!data.token) {
        throw new Error('Nie otrzymano tokenu z serwera');
      }
      localStorage.setItem('token', data.token);
      setIsAuthenticated(true);
      return true;
    } catch (err) {
      console.error('Błąd weryfikacji rejestracji:', err);
      setError(err.message || 'Wystąpił błąd podczas weryfikacji rejestracji');
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{
      isAuthenticated,
      error,
      isLoading,
      login,
      registerInit,
      registerVerify,
      logout
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext); 